// Pane → Interactions → one tenant: the overview narrowed to it (KPIs, how its panes close, the screens passengers saw inside it, the
// daily trend and the hours) and the cabs it was used on (the cab register, tenant-filtered — each row a door to the cab's timeline).
// Reads: the same two routes with ?tenant= (routes/paneInteractions.js).
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { PageHead, Loading, ErrorState, Empty, Button } from '../../components/ui';
import ob from '../fleet/Onboarding.module.css';
import { KpiTiles, TrendCards, ScreensTable, CabRegister, useOverview } from './Interactions';
import { useWindow, FilterBar, CloseCauses, tenantLabel, tenantKind, isBenchDemo, num, ix as s } from './interactionsLib';

export default function InteractionsTenant() {
  const { tenantId } = useParams();
  const win = useWindow({ fixedTenant: tenantId });
  const q = useOverview(win);
  const d = q.data; const t = (d?.tenants || [])[0];
  return (
    <div className={ob.wrap}>
      <div className={s.crumbs}><Link to={`/v2/pane/interactions${win.linkQs()}`}>← Interactions</Link></div>
      <PageHead title={<>{tenantLabel(tenantId)}{isBenchDemo(tenantId) && <span className={`${s.tag} ${s.tagDim}`}>bench demo</span>}</>}
        sub={<>{tenantKind(tenantId, t?.tenant_kind)} · <code>{tenantId}</code> — how passengers used it in the window, and on which cabs.</>}
        actions={<Button onClick={q.reload}>Refresh</Button>} />
      <div className={s.doors} style={{ margin: '-8px 0 16px' }}><Link className={ob.btnTool} to="/v2/pane/catalogue">Catalogue →</Link></div>
      <FilterBar win={win} data={d} ob={ob} showTenants={false} />
      {q.loading && !d ? <Loading what="the tenant" /> : q.error ? <ErrorState error={q.error} onRetry={q.reload} /> : !d ? null : !d.panes?.panes ? (
        <Empty title={`No ${tenantLabel(tenantId)} pane in this window`}>Try a longer range{win.bench ? '' : ', or include the bench'}.</Empty>
      ) : (<>
        <KpiTiles d={d} />
        <div className={s.grid2even}>
          <section className={s.card} data-card="close">
            <div className={s.cardHead}><div><h3 className={s.cardTitle}>How its panes close</h3><p className={s.cardSub}>{num(d.panes.panes)} panes · {num(d.panes.steps)} in-app events · {num(d.panes.strip_touches)} strip touches while open</p></div></div>
            <CloseCauses causes={d.causes} map={d.cause_group} />
          </section>
          <section className={s.card} data-card="screens">
            <div className={s.cardHead}><div><h3 className={s.cardTitle}>Screens passengers saw</h3><p className={s.cardSub}>Reported by the app (tenant_event screen, or the page's screen_shown).</p></div></div>
            <ScreensTable d={d} limit={20} showTenant={false} />
          </section>
        </div>
        <TrendCards d={d} />
      </>)}
      <h2 className={s.sectionTitle}>Cabs it was opened on</h2>
      <CabRegister win={win} />
    </div>);
}
